import Box from '@mui/material/Box'

import { Navigation } from '../../nav'
import { Outlet } from '../../router/components/Outlet'

export { DefaultLayout }

const DefaultLayout = () => {
  return (
    <>
      <Navigation />

      <Box
        component="main"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
      >
        <Outlet />
      </Box>
    </>
  )
}
